/* eslint-disable react-hooks/exhaustive-deps */

import { useMemo } from 'react';
import { StayDates } from 'types';
import { doDatesContain } from 'lib/utils';

export const useDoDatesContain = (outer: StayDates, inner: Partial<StayDates> = {}) => {
  return useMemo(() => {
    return doDatesContain(outer, inner);
  }, [outer.checkIn, outer.checkOut, inner.checkIn, inner.checkOut]);
};
